import React from 'react'
import { AppLayout } from '@/components/layouts/AppLayout'
import { TaskDetailContent, TaskDetail, BoardInfo } from '@/components/tasks/TaskDetailContent'
import { Issue } from '@/components/tasks/IssueList'
import { SubTask } from '@/components/tasks/SubTaskList'
import { AttachmentData } from '@/components/tasks/AttachmentItem'
import { useBoardChannel } from '@/hooks/useBoardChannel'

interface AgentRef {
  id: number
  username: string
  slug: string
}

interface BoardRef {
  id: number
  name: string
  slug: string
  agents?: AgentRef[]
}

interface ParentTask {
  id: number
  summary: string
  status: string
  status_color: string
  status_label: string
  board: BoardRef
  web_url: string
}

interface Props {
  tab: string
  board: BoardInfo
  task: TaskDetail
  board_agents: AgentRef[]
  sub_tasks: SubTask[]
  parent_task: ParentTask | null
  accessible_boards: BoardRef[]
}

export default function Show({ tab, board, task, board_agents, sub_tasks, parent_task, accessible_boards }: Props) {
  useBoardChannel(board.id, { only: ['task', 'sub_tasks'] })

  return (
    <AppLayout>
      <TaskDetailContent
        tab={tab}
        board={board}
        task={task}
        board_agents={board_agents}
        sub_tasks={sub_tasks}
        parent_task={parent_task}
        accessible_boards={accessible_boards}
        backLink={{ href: '/tasks/all', label: 'Back to all tasks' }}
      />
    </AppLayout>
  )
}
